var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.viewBoxWidth,"x":_vm.containerX,"y":_vm.containerY}},[_c('svg',{attrs:{"viewBox":(_vm.followPath === '' ? -(_vm.viewBoxWidth / 2) : 0) + ' ' + _vm.localY + ' ' + _vm.viewBoxWidth + ' 2400'}},[(_vm.followPath === '')?_c('text',{class:_vm.textClassName,style:({
                'text-anchor': _vm.textAnchor,
                'transform': _vm.transform,
                '-webkit-transform': _vm.transform
            }),attrs:{"transform":_vm.transformNoDeg},domProps:{"innerHTML":_vm._s(_vm.out)}}):_vm._e(),_vm._v(" "),(_vm.followPath !== '')?_c('text',{class:_vm.textClassName,style:({
                'text-anchor': _vm.textAnchor,
                'transform': _vm.transform,
                '-webkit-transform': _vm.transform
            })},[(_vm.followPath !== '')?_c('textPath',{attrs:{"xlink:href":'#' + _vm.followPath,"startOffset":_vm.startOffset},domProps:{"innerHTML":_vm._s(_vm.out)}}):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc76856","hasScoped":false,"buble":{"transforms":{}}}!./src/components/fit-svg-text/template.svg
// module id = 913
// module chunks = 0